export default __webpack_public_path__ + "static/media/p4.f76a9fb4.jpg";